var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.99935 0.666656C4.39685 0.666656 0.666016 4.39749 0.666016 8.99999C0.666016 13.1592 3.71352 16.6067 7.69768 17.2325V11.4083H5.58102V8.99999H7.69768V7.16416C7.69768 5.07582 8.94102 3.92249 10.8452 3.92249C11.7568 3.92249 12.7102 4.08499 12.7102 4.08499V6.13499H11.6602C10.6243 6.13499 10.3018 6.77749 10.3018 7.43666V8.99999H12.6127L12.2435 11.4083H10.3018V17.2325C14.2852 16.6075 17.3327 13.1583 17.3327 8.99999C17.3327 4.39749 13.6018 0.666656 8.99935 0.666656Z","fill":"#55527C"}));
}

FacebookInline.defaultProps = {"width":"25","height":"25","viewBox":"0 0 18 18","fill":"none"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
